import { Box, Chip, Typography } from "@mui/material";
import { useRef, useState, useEffect } from "react"
import useMobileScreen from "../../../../lib/useMobileScreen";

export default function Descricao({
    titulo,
    descricao,
}: DescricaoProps) {

    const telaMobile = useMobileScreen()
    const textoDescricao = useRef<HTMLPreElement>(null);

    const [descricaoExpandida, setDescricaoExpandida] = useState<boolean>(false)
    const [preAtingiuAltura, setPreAtingiuAltura] = useState(false);

    const alturaLimite = 300;
    useEffect(() => {
        if (descricao && textoDescricao.current) {
            const alturaEl = textoDescricao.current.scrollHeight;
            setPreAtingiuAltura(alturaEl > alturaLimite);
        }
    }, [descricao, textoDescricao]);

    return (
        <>
            <Box>
                <Typography variant="caption">Título</Typography>
                <Typography fontSize={22} fontWeight="bold">{titulo}</Typography>
            </Box>
            <Box>
                <pre
                    ref={textoDescricao}
                    style={{
                        fontSize: 11,
                        padding: 12,
                        overflow: "auto",
                        maxWidth: telaMobile ? 400 : "unset",
                        maxHeight: descricaoExpandida ? "unset" : 300,
                        overflowY: "hidden",
                        backgroundColor: '#EEE',
                    }}
                    className="print-descricao-detalhe"
                    dangerouslySetInnerHTML={{ __html: descricao }}
                />

                {
                    preAtingiuAltura &&
                    <Box position="relative" top={-11}>
                        <Chip
                            label={descricaoExpandida ? "Ocultar" : "Ler mais"}
                            size="small"
                            variant="outlined"
                            color="primary"
                            onClick={() => setDescricaoExpandida(prevState => !prevState)}
                            className="hide-on-print"
                            sx={{
                                position: "absolute",
                                top: -12,
                                left: "50%",
                                transform: "translate(-50%, 0)",
                                cursor: "pointer",
                                alignItems: "center",
                                gap: 0.5
                            }}
                        />
                    </Box>
                }
            </Box>
        </>
    )
}

interface DescricaoProps {
    titulo: string,
    descricao: string
}